// extracted by mini-css-extract-plugin
module.exports = {"productReviewsContainer":"styles_productReviewsContainer__1lb-j"};